import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import './index.css';
import "@fontsource-variable/nunito-sans";
var root;

// This initialization code is based on a previous component which can be found at 
// https://github.com/Member-Advantage-Mortgage/mam-rent-vs-buy-calculator/blob/master/src/index.jsx
if (window.MAM) {
  console.log("MAM object found. Rendering to mam-rent-vs-buy-calculator v20230517");
  // iterate through each widget instance and render if the id exists in the DOM
  const refiWidgets = window.MAM.configuration.widgets
    .filter((w) => {
      return w.type === "RefiCalculatorWIP";
    });

  refiWidgets.forEach((widget) => {
    widget.siteId = window.MAM.configuration.siteId;
    widget.disclaimerTemplate =
      window.MAM.configuration.rentVsBuyCalculatorDisclaimerTemplate;

    const elem = document.getElementById(widget.id);
    if (!elem) return;

    console.log("Widget Config", widget);

    var root = ReactDOM.createRoot(elem);

    root.render(
      <div className="mam-widget">
        <App />
      </div>
    );
  });
} else {
  console.log("MAM not found. Rendering to root", window.MAM);
  root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}